import { useUser } from '@/store/user'

const normalizePermissions = (permissions) => {
  if (!permissions) {
    return []
  }

  return Array.isArray(permissions) ? permissions : [permissions]
}

const hasPermissions = (meta) => {
  const permissions = normalizePermissions(meta.permissions)

  if (!permissions.length) {
    return true
  }

  const user = useUser()
  const strategy = meta.permissionStrategy || 'every'

  if (strategy === 'some') {
    return permissions.some((permission) => user.can(permission))
  }

  return permissions.every((permission) => user.can(permission))
}

export const permMiddleware = (to) => {
  if (Object.hasOwnProperty.call(to.meta, 'permissions')) {
    if (!hasPermissions(to.meta)) {
      return '/'
    }
  }
}
